import * as React from 'react';
import { useRef, useState, useContext, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import { TimerDismissButton as TimerDismissButton$1, TimerProgress } from './styles.js';
import { Close } from '../Icons/components/Close.js';

const DEFAULT_TIMEOUT_IN_MS = 4000;
const TimerDismissButton = ({ className , onDismiss , timeout =DEFAULT_TIMEOUT_IN_MS  })=>{
    const timeoutRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const theme = useContext(ThemeContext);
    useEffect(()=>{
        setProgress(100);
        timeoutRef.current = window.setTimeout(()=>{
            onDismiss();
        }, timeout);
        return ()=>{
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [
        onDismiss,
        timeout
    ]);
    return /*#__PURE__*/ React.createElement(TimerDismissButton$1, {
        small: true,
        className: className,
        onClick: onDismiss,
        icon: /*#__PURE__*/ React.createElement(Close, {
            color: theme.colors["Level 5"]
        })
    }, /*#__PURE__*/ React.createElement(TimerProgress, {
        progress: progress,
        diameter: 32,
        stroke: 2,
        color: theme.colors["Level 4"],
        animationDuration: timeout
    }));
};

export { TimerDismissButton };
